import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { attachIconWithCountStyle } from './AttachIconWithCount.style';
export var AttachIconWithCount = function (_a) {
    var _b, _c, _d, _e;
    var onClick = _a.onClick, disableAttach = _a.disableAttach, filesCount = _a.filesCount;
    var classes = attachIconWithCountStyle().classes;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { onClick: function () { return onClick(); }, style: { height: 'fit-content', cursor: 'pointer' }, className: clsx((_b = {},
                    _b[classes.attachDisableText] = disableAttach,
                    _b)), children: [_jsx(AttachFileIcon, { "data-testid": 'attachFileIcon', className: clsx((_c = {},
                            _c[classes.attachFileIcon] = true,
                            _c[classes.attachDisableText] = disableAttach,
                            _c)) }), _jsx(Typography, { component: "div", variant: 'h5', className: clsx((_d = {},
                            _d[classes.attachFileText] = true,
                            _d[classes.attachDisableText] = disableAttach,
                            _d)), children: "Attach" })] }), _jsx(Box, { children: _jsx(Typography, { component: "div", className: clsx((_e = {},
                        _e[classes.attachDisableText] = disableAttach,
                        _e)), children: "".concat(filesCount || 'No', " ").concat(filesCount === 1 ? 'Item' : 'Items') }) })] }));
};
